import { NavLink } from 'react-router-dom';
import { Home, Briefcase, Mic, CalendarCheck, User } from 'lucide-react';

const navItems = [
  { to: '/', icon: Home, label: '首页' },
  { to: '/jobs', icon: Briefcase, label: '岗位' },
  { to: '/interview', icon: Mic, label: '面试' },
  { to: '/attendance', icon: CalendarCheck, label: '考勤' },
  { to: '/profile', icon: User, label: '我的' },
];

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-slate-200 bg-white safe-area-bottom">
      <div className="mx-auto flex max-w-lg items-center justify-around">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 py-2 px-3 text-xs font-medium transition-colors ${
                isActive ? 'text-emerald-600' : 'text-slate-400'
              }`
            }
          >
            <item.icon className="h-5 w-5" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
